import { render } from "./AvisoLegal.vue?vue&type=template&id=8c83d030&scoped=true"
import script from "./AvisoLegal.vue?vue&type=script&lang=js"
export * from "./AvisoLegal.vue?vue&type=script&lang=js"

import "./AvisoLegal.vue?vue&type=style&index=0&id=8c83d030&scoped=true&lang=css"

import exportComponent from "/var/www/html/quanty/quanty-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c83d030"]])

export default __exports__